<template>
    <b-col cols="12">
        <b-form-group :label="$t(config.label)">
            <v-select
                :multiple="config.multiple"
                :close-on-select="false" 
                v-model="selected"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="option => option.name"
                :options="options"
            />
            <b-form-invalid-feedback v-if="errors && (config.key in errors)" :state="errors && (config.key in errors) ? false : null">
            {{ $t(errors[config.key][0]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        </b-col>
</template>

<script>

import vSelect from '@/utils/vselect.vue'
import { ref, computed, watch } from '@vue/composition-api'
import { BCol, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';

export default {
    components: {
      BCol,
      BFormGroup,
      vSelect,
      BFormInvalidFeedback
    },
    emit:['updateRequest'],
    props: {
      config:{
        type:Object
      },
      data:{
        type:Object
      },
      request:{
        type:Object
      },
      errors:{
        type:Object
      }
    },
    setup(props, { emit, root }) {

      const selected = ref(props.config.multiple ? [] : null)

      const options = computed(()=> {

          let options = [];

          if(props.config.allOption){
            let allOption = {name:root.$t('all')}
            allOption[props.config.selectionKey] = 'all'
            options.push(allOption)
          }

          options.push(...props.data[props.config.options])

          return options
      })

        watch([selected], ()=> {
          emit('updateRequest', {
              key:props.config.key,
              value: props.config.multiple ? selected.value.map((option) => option[props.config.selectionKey]) : (selected.value ? selected.value[props.config.selectionKey] : null)
            })
        })

        return {
          selected,
          options
        }
    }
}
</script>
